package org.maplibre.compose.overlay

import androidx.compose.runtime.Composable

@Composable internal actual fun systemDefaultPrimaryMeasure(): ScaleBarMeasure? = null
